import page from '@/pages/NewDeploymentPage.module.css'
import styles from './Infrastructure.module.css'

interface YesNoQuestionProps {
  /** The question, which is also the group's accessible name. */
  question: string
  /** The radio group's name. Must be unique on the page. */
  name: string
  /** The answer, or null while the question is unanswered (neither radio is then checked). */
  value: boolean | null
  onChange: (answer: boolean) => void
  /** One line of explanation under the answers. */
  hint?: string
}

/**
 * A required Yes/No question: a labelled radio group of two real radio inputs, so the arrow keys, Tab and screen readers
 * behave natively. It starts unanswered, and the "To continue:" list of the flow says so until it is answered.
 */
export function YesNoQuestion({ question, name, value, onChange, hint }: YesNoQuestionProps) {
  const hintId = `${name}-hint`
  return (
    <fieldset role="radiogroup" aria-required="true" aria-describedby={hint ? hintId : undefined} style={{ border: 'none', padding: 0, margin: 0 }}>
      <legend className={styles.legend}>
        {question} <span aria-hidden="true" className={page.required}>*</span>
      </legend>
      <div className={page.radioGroup}>
        <label className={page.radioOption}>
          <input type="radio" name={name} value="yes" checked={value === true} onChange={() => onChange(true)} />
          Yes
        </label>
        <label className={page.radioOption}>
          <input type="radio" name={name} value="no" checked={value === false} onChange={() => onChange(false)} />
          No
        </label>
      </div>
      {hint && (
        <span id={hintId} className={page.fieldHint}>
          {hint}
        </span>
      )}
    </fieldset>
  )
}
